import { Module } from 'vuex';

import { RootState } from './types';
import { StoreState } from '@/types';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

const state: RootState = {
  state: '',
  lastErr: null,

  timezone: 'Africa/Johannesburg',

  // order info
  packageGroups: [],
  packages: [],
  salesConsultants: [],

  // pivot info
  views: undefined,

  // global selected account
  globalSelectedAccount: undefined,

  snackbarState: false,
  snackbarText: "",

  serviceMatrix: [],
  warehouses: [],
  warehousepackages: []
};

const module: Module<RootState, StoreState> = {
  state,
  getters,
  mutations,
  actions,
};

export default module;
